export const buildUrlParams = (obj: Record<string, string | string[]>, urlSearchParams: URLSearchParams) => {
  const newUrlSearchParams = new URLSearchParams(urlSearchParams.toString())
  for(const key in obj) {
    if(newUrlSearchParams.has(key)) {
      if(Array.isArray(obj[key])) {
        newUrlSearchParams.delete(key);
        (obj[key] as string[]).forEach((value) => newUrlSearchParams.append(key, value))
      } else {
        if(obj[key] !== '') {
          newUrlSearchParams.set(key, (obj[key] as string))
        } else {
          newUrlSearchParams.delete(key)
        }
      }
    } else {
      newUrlSearchParams.append(key, (obj[key] as string))
    }
  }
  return newUrlSearchParams
}
